import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={(styles["bi"] || "bi") + " " + (styles["bi-arrow-down-circle-fill"] || "bi-arrow-down-circle-fill")} viewBox="0 0 16 16" {...props}><path d="M16 8A8 8 0 110 8a8 8 0 0116 0M8.5 4.5a.5.5 0 00-1 0v5.793L5.354 8.146a.5.5 0 10-.708.708l3 3a.5.5 0 00.708 0l3-3a.5.5 0 00-.708-.708L8.5 10.293z" /></svg>);